import React from "react";
import { Modal, ModalBody } from "reactstrap";
import closeicon from "assets/images/closeicon.svg";
import { ReceiptModalShell } from "components/receiptPage/receiptEmailModal.styles";

export default function Model(props) {
  let { isOpen, toggle, children, variant = "default" } = props;
  const isReceipt = variant === "receipt";

  const modal = (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
      size="sm"
      contentClassName={isReceipt ? "rp-receipt-modal" : undefined}
    >
      {isReceipt ? (
        <button
          type="button"
          className="rp-modal-close"
          onClick={toggle}
          aria-label="Close"
        >
          ×
        </button>
      ) : (
        <img
          src={closeicon}
          height={32}
          width={32}
          alt="Close"
          style={{
            position: "absolute",
            right: 10,
            top: 10,
            cursor: "pointer"
          }}
          onClick={() => toggle()}
        />
      )}
      <ModalBody className={isReceipt ? "" : "mt-40"}>{children}</ModalBody>
    </Modal>
  );

  if (isReceipt) {
    return <ReceiptModalShell>{modal}</ReceiptModalShell>;
  }

  return <div>{modal}</div>;
}
